export default values => ({
  taxSystem: values.taxSystem || '',
  taxSystemId: values.taxSystemId || ''
});
